import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/6a8d4e2f755b8c001444a9e3_1787655469191_c4e52cb4/tradeedge/src/app/analytics/page.tsx");
